var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-main"},[_vm._v("报价单列表")])
}
var staticRenderFns = []

export { render, staticRenderFns }